import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function DeviceInfo() {
  const { t } = useTranslation();

  const platform = useMemo(() => {
    if (navigator.userAgent.includes('Tizen')) {
      return 'Tizen';
    } else if (navigator.userAgent.includes('WebOS') || navigator.userAgent.includes('Web0S')) {
      return 'WebOS';
    } else {
      return 'Web';
    }
  }, []);

  return (
    <div className="mt-12">
      <p className="text-[34px] font-bold">{`• ${t('page_device_info_os')} - ${platform}`}</p>
    </div>
  );
}
